<template>
    <div class="p-30 pt-10">

        <div class="flex jc-sb mb-20">
            <el-button size="small">返回</el-button>
        </div>

        <div class="flex jc-sb mb-20">

            <div class="flex jc-fs">
                <div>提交审核时间：</div>
                <el-date-picker v-model="val" type="daterange" range-separator="至" start-placeholder="开始日期"
                    end-placeholder="结束日期">
                </el-date-picker>
            </div>

            <div>
                <el-button type="primary" @click="search()">
                    <i class="el-icon-search" style="margin-right: 5px;"></i>查询
                </el-button>
                <el-button @click="search('refresh')">
                    <i class="el-icon-refresh" style="margin-right: 5px;"></i>重置
                </el-button>
            </div>

        </div>

        <div class="flex jc-sb mb-20">
            <el-button type="primary" plain>批量审批</el-button>
        </div>

        <dyTable v-if="studentList.length > 0" ref="table" :columns="columns" :table-data="studentList"
            v-loading="tableLoading" :total="total" :page-num="pageNo" :page-size="pageSize"
            @current-change="pageNoChange" element-loading-text="加载中">
        </dyTable>



    </div>
</template>

<script>
import { queryUserInfo, findAllSchool, updateUserDetail, queryUserDetails } from '@/api/index';
import { encrypt, decrypt } from '@/api/common_encrypt';
import dyTable from '@/components/common/dytable'


export default {
    name: 'approvalList',
    components: {
        dyTable
    },
    data() {
        return {
            loading: false,
            tableLoading: false,

            val: "",
            columns: [],
            studentList: [{}],
            pageNo: 1,
            pageSize: 10,
            total: 100,

        };
    },
    mounted() {
        this.columns = [
            {
                type: 'index',
                title: '序号'
            },
            {
                key: 'textName',
                title: '姓名'
            },
            {
                key: 'categoryName',
                title: '学号'
            },
            {
                key: 'bgUserName',
                title: '所属学校'
            },
            {
                key: 'bgUserName',
                title: '提交审核时间'
            },
            {
                key: '',
                title: '操作',
                width: 300,
                render: ({ row }) => {
                    return (
                        <div>
                            <el-link type="primary" onClick={() => this.detail(row)}>同意</el-link>
                            <el-link type="danger" style="margin-left:12px" onClick={() => this.delete(row)}>忽略</el-link>
                        </div>
                    );
                }
            },
        ];

    },
    computed: {

    },
    methods: {

        pageNoChange() {

        },


    }
};
</script>

<style lang='scss' scoped></style>
